import React, {useState, useEffect} from 'react';
import { useStyles } from "./style";
import Table from 'components/Table';

function TablaTransaccional(props) {
    let nombreCompleto = '', lugarNacimiento='', lugarResidencia='', estadoPadronFormato='', generoFormato='';
    const classes = useStyles()
    useEffect(() => {
        if(props.tablaTransaccional){
            for (let index = 0; index < props.tablaTransaccional.length; index++) {               
                nombreCompleto = (
                    (props.tablaTransaccional[index]?.nombre1 ? (props.tablaTransaccional[index]?.nombre1+' ') : '')+
                    (props.tablaTransaccional[index]?.nombre2 ? (props.tablaTransaccional[index]?.nombre2) : '')+
                    (props.tablaTransaccional[index]?.apellido1 ? (' , '+props.tablaTransaccional[index]?.apellido1+' ') : '')+
                    (props.tablaTransaccional[index]?.apellido2 ? (props.tablaTransaccional[index]?.apellido2+' ') : '')+
                    (props.tablaTransaccional[index]?.apellido3 ? props.tablaTransaccional[index]?.apellido3 : '')
                )
                lugarNacimiento = (
                    (props.tablaTransaccional[index]?.departamentoNacimiento?.nameShort ? (props.tablaTransaccional[index]?.departamentoNacimiento?.nameShort+' , ') : '')+
                    (props.tablaTransaccional[index]?.municipioNacimiento?.municipio ? (props.tablaTransaccional[index]?.municipioNacimiento?.municipio) : '')
                    )
                lugarResidencia = (
                    (props.tablaTransaccional[index]?.departamentoResidencia?.nameShort ? (props.tablaTransaccional[index]?.departamentoResidencia?.nameShort+' , ') : '')+
                    (props.tablaTransaccional[index]?.municipioResidencia?.municipio ? (props.tablaTransaccional[index]?.municipioResidencia?.municipio) : '')
                    )
                estadoPadronFormato = (
                    (props.tablaTransaccional[index]?.estadoPadron?.codStatus ? (props.tablaTransaccional[index]?.estadoPadron?.codStatus+'. ') : '')+
                    (props.tablaTransaccional[index]?.estadoPadron?.nombreStatus ? (props.tablaTransaccional[index]?.estadoPadron?.nombreStatus) : '')
                )
                generoFormato = (
                    (props.tablaTransaccional[index]?.genero === 0 ? 'Femenino' : (props.tablaTransaccional[index]?.genero === 1) ? 'Masculino' : '')
                )
                props.tablaTransaccional[index].nombreCompleto = nombreCompleto
                props.tablaTransaccional[index].lugarNacimiento = lugarNacimiento
                props.tablaTransaccional[index].lugarResidencia = lugarResidencia
                props.tablaTransaccional[index].estadoPadronFormato = estadoPadronFormato
                props.tablaTransaccional[index].generoFormato = generoFormato
            }
        }
    }, [props.tablaTransaccional])
    const header = [
        { title: 'Transaccional No. ', field: 'id'},
        { title: 'Nombre completo', field: 'nombreCompleto'},
        { title: 'No. Boleta', field: 'nroboleta'},
        { title: 'Estado en el Padrón', field: 'estadoPadronFormato'},
        { title: 'Género', field: 'generoFormato'},
        { title: 'Lugar Residencia', field: 'lugarResidencia'},
        { title: 'Fecha de nacimiento', field: 'fechanacimientoFormato'},
        { title: 'Lugar de nacimiento', field: 'lugarNacimiento'},
    ]
    return (
        <div className={classes.table}>
            <Table
                title={"Historial transaccional"}
                header = {header}
                data = {props.tablaTransaccional||[]}
                pageSize = {5}
                showFilterGeneral={false}
            />
        </div>
    );
}
export default TablaTransaccional;